import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../audi-ui-components/Button';
import IconPoi from '../../audi-ui-components/icons/Poi';
import IconVoiceCall from '../../audi-ui-components/icons/VoiceCall1';
import IconCancel from '../../audi-ui-components/icons/Cancel';
import { parse as phoneParse, getPhoneCode } from 'libphonenumber-js';
import { gtmPush } from '../../functions/gtm';
import {
    PATH_XTIME
} from '../../constants';

class SearchResult extends React.Component {
    render() {
        // const {phone, webkey, dealerId, latitude, longitude, directionUrl} = this.props;
        const {
          id,
          locationId,
          name,
          address,
          suburb,
          postcode,
          state,
          webKey,
          phone,
          latitude,
          longitude,
          mapsURL,
          dealer
        } = this.props;
        let _phone = phone || dealer.phone;
        let parsedPhoneNum = phoneParse(_phone, 'AU');
        let telLink = _phone;
        if (parsedPhoneNum && parsedPhoneNum.phone) {
            telLink = '+61' + parsedPhoneNum.phone;
        }
        let hasClose = typeof this.props.onClickClose === "function";
        return (
            <div className="result">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-medium mb-3">
                    <div className="row">
                      <div className="col">
                        <h2 className="aui-headline-4 mb-3"><b>{name}</b></h2>
                        <p className="mb-3"><IconPoi small className="align-text-bottom" /> {address}, {suburb} {state} {postcode}</p>
                        <p className=""><IconVoiceCall small /> <a href={`tel:${telLink}`} className="aui-textlink" onClick={()=>{ gtmPush("dealerBookAService", "call", "dealerBookAService", {dealerName: dealer.name}); }}>{phone}</a></p>
                      </div>
                      {hasClose && <div className="col-auto d-medium-none">
                        <Button variant="icon" icon={<IconCancel small />} onClick={this.props.onClickClose} />
                      </div>}
                    </div>
                  </div>
                  <div className="col-12 col-medium-auto">
                    {hasClose && <p className="aui-color-text-gray50 mb-4 text-end d-none d-medium-block">
                      <Button variant="icon" icon={<IconCancel small />} onClick={this.props.onClickClose} />
                    </p>}
                    {webKey &&
                      <Button
                        variant="primary"
                        className="booknow mb-2"
                        href={`${PATH_XTIME}/${dealer.dealerCode}/${locationId}`}
                        onClick={(e) => {
                            e.preventDefault();
                            gtmPush("dealerBookAService", "bookNow", "dealerBookAService", {dealerName: dealer.name});
                            this.props.onClickBook();
                            return false;
                        }}
                      >Book Online</Button>
                    }
                    {((latitude && longitude) || mapsURL) &&
                        <Button label="Get directions"
                            variant="secondary"
                            className="getdirections"
                            href={mapsURL ? mapsURL : `https://www.google.com/maps/dir//${latitude},${longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => { trackEvent('DirectionsClicked'); }}
                        />
                    }
                  </div>
                </div>
              </div>
            </div>
        );
    }
}

export default SearchResult;
